import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import FaceIcon from "@material-ui/icons/Face";
import GroupIcon from "@material-ui/icons/Group";
import SettingsIcon from "@material-ui/icons/Settings";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkRequiredPermissions, USER_GROUPS } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import CollapseGroup from "../CollapseGroup";

/**
 * ContactsModule
 * DeviceModule
 * MaintenanceModule
 * SoftwareModule
 * SystemModule
 */
export default function SoftwareModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  // Allowed Uswer groups
  return checkRequiredPermissions([USER_GROUPS.ADMIN]) ? (
    <CollapseGroup
      mainItemAction={() => {
        history.push("/cpanel/system");
        dispatch(showSidebar(false));
      }}
      mainItemIcon={<SettingsIcon />}
      header={t("system.header")}
    >
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/users");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <GroupIcon />
        </ListItemIcon>
        <ListItemText primary={t("adminSideBar.users")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/settings");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <FaceIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.settings")} />
      </ListItem>
    </CollapseGroup>
  ) : null;
}
